module.exports = __webpack_public_path__ + "media/images/chang_testimonial_2x-0dc029e5f3ddc3a30f13f76f56161895.png";